import Guest from '@/layouts/guest';
import React, {useEffect, useState} from 'react';
import {Container, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import ArtistDetailsSidebar from "@/components/global/artists/details-sidebar";
import PostItem from "@/components/global/posts/item";
import {useDispatch} from "react-redux";
import ArtistsService from "@/services/artists-service";
import {ALERT} from "@/actions/types";
import Loader from "@/components/global/loader";
import { setCanonical } from '@/app/general';

const ArtistDetails: React.FC = (props: any) => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [artist, setArtist] = useState<IArtistDetails | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        setCanonical();
        if(params.id) {
            ArtistsService.getArtist(params.id || '').then((artist: IArtistDetails) => {
                setArtist(artist);
            }).catch(() => {
                dispatch({
                    type: ALERT,
                    payload: { message: { result: 0, message: 'دریافت اطلاعات آرتیست موردنظر با خطا مواجه شد. لطفا صفحه را رفرش نمایید!' } }
                });
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [dispatch, params.id]);


    return (
        <Guest title={artist?.name || "جزئیات آرتیست"}>
            <Container className="py-5">
                {loading ? <Loader /> : (
                    <Row>
                        <div className="col-lg-3 col-md-4 mb-lg-0 mb-4 mx-auto" style={{maxWidth: '400px'}}>
                            <ArtistDetailsSidebar artist={artist} />
                        </div>
                        <div className="col-lg-9 col-md-8">
                            <Row>
                                {artist?.posts.map((post, idx) => (
                                    <div key={'arpost' + post.id + Math.random()} className="col-lg-4 col-sm-6 mx-auto mb-4" style={{ maxWidth: '300px' }}>
                                        <PostItem post={post} />
                                    </div>
                                ))}
                            </Row>
                        </div>
                    </Row>
                )}
            </Container>
        </Guest>
    );
}

export default ArtistDetails;
